'use client'
import { ErrorBoundary } from 'react-error-boundary'
import React from 'react'

function FallbackComponent(): React.ReactNode {
  return <></>
}

export default function ErrorBoundaryWrapper({
  children,
}: {
  children: React.ReactNode
}): React.ReactNode {
  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onError={(error) => {
        window?.newrelic?.noticeError(
          `Client error from ErrorBoundaryWrapper: ${
            error?.message ? error.message : error
          }`,
        )
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
